import { FilterType } from "../model";
/** our unique property key for a node */
const nodeKey = Symbol("auvious");
export function setAttachment(node, attributes, text, filter = FilterType.None) {
    return (node[nodeKey] = {
        id: 0,
        attributes,
        text,
        filter,
    });
}
export function getAttachment(node) {
    return node[nodeKey];
}
export function hasAttachment(node) {
    return !!node[nodeKey];
}
export function removeAttachment(node) {
    node[nodeKey] = undefined;
}
//# sourceMappingURL=attachment.js.map